"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyChatMessage = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const chat_helpers_1 = require("@/components/domains/chat/chat.helpers");
const utils_1 = require("@/utils");
let MyChatMessage = class MyChatMessage extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.datetime = '';
        this.failed = false;
    }
    render() {
        return (0, lit_1.html) `
      <slot></slot>
      ${(0, chat_helpers_1.renderChatMessageFailedActions)(this.failed, () => this.handleRetryClick())}
      ${(0, chat_helpers_1.renderChatMessageTime)(this.datetime)}
    `;
    }
    handleRetryClick() {
        (0, utils_1.emit)(this, 'retry');
    }
};
MyChatMessage.styles = (0, lit_1.css) `
    :host {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      gap: var(--space-2);
    }

    .failed-actions {
      display: flex;
      align-items: center;
      gap: var(--space-1);
    }

    ::slotted(mm-my-chat-bubble) {
      align-self: flex-end;
    }

    :host([failed]) ::slotted(mm-my-chat-bubble) {
      --chat-bubble-background-color: color-mix(
        in srgb,
        var(--danger-color) 12%,
        var(--background-color)
      );
      --chat-bubble-border: var(--border-danger);
      --chat-bubble-text-color: var(--foreground-color);
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ type: String })
], MyChatMessage.prototype, "datetime", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean, reflect: true })
], MyChatMessage.prototype, "failed", void 0);
MyChatMessage = __decorate([
    (0, decorators_js_1.customElement)('mm-my-chat-message')
], MyChatMessage);
exports.MyChatMessage = MyChatMessage;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibXktY2hhdC1tZXNzYWdlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibXktY2hhdC1tZXNzYWdlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUEyQztBQUMzQyxxREFBMkQ7QUFFM0QseUVBRytDO0FBQy9DLG1DQUE4QjtBQUd2QixJQUFNLGFBQWEsR0FBbkIsTUFBTSxhQUFjLFNBQVEsZ0JBQVU7SUFBdEM7O1FBNkJ1QixhQUFRLEdBQUcsRUFBRSxDQUFBO1FBQ0csV0FBTSxHQUFHLEtBQUssQ0FBQTtJQWE1RCxDQUFDO0lBWEMsTUFBTTtRQUNKLE9BQU8sSUFBQSxVQUFJLEVBQUE7O1FBRVAsSUFBQSw2Q0FBOEIsRUFBQyxJQUFJLENBQUMsTUFBTSxFQUFFLEdBQUcsRUFBRSxDQUFDLElBQUksQ0FBQyxnQkFBZ0IsRUFBRSxDQUFDO1FBQzFFLElBQUEsb0NBQXFCLEVBQUMsSUFBSSxDQUFDLFFBQVEsQ0FBQztLQUN2QyxDQUFBO0lBQ0gsQ0FBQztJQUVPLGdCQUFnQjtRQUN0QixJQUFBLFlBQUksRUFBQyxJQUFJLEVBQUUsT0FBTyxDQUFDLENBQUE7SUFDckIsQ0FBQzs7QUF6Q00sb0JBQU0sR0FBRyxJQUFBLFNBQUcsRUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0dBMkJsQixDQUFBO0FBQzJCO0lBQTNCLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsQ0FBQzsrQ0FBYztBQUNHO0lBQTNDLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxPQUFPLEVBQUUsT0FBTyxFQUFFLElBQUksRUFBRSxDQUFDOzZDQUFlO0FBOUIvQyxhQUFhO0lBRHpCLElBQUEsNkJBQWEsRUFBQyxvQkFBb0IsQ0FBQztHQUN2QixhQUFhLENBMkN6QjtBQTNDWSxzQ0FBYSJ9